import type { Theme } from '../../themes/themes';

export const createLinkTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          display: 'inline',
          textDecorationThickness: '1px !important',
          color: theme.palette.text.linkDefault,
          textDecorationColor: 'inherit',
          textUnderlineOffset: '0.25em',
          wordBreak: 'break-word',

          '&[href^="tel:"]': {
            textDecorationThickness: '1px',
          },

          '&:hover': {
            color: theme.palette.text.linkHover,
            textDecorationColor: 'inherit',
          },

          '&:active': {
            color: theme.palette.text.linkActive,
            textDecorationColor: 'inherit',
          },

          '&:focus-visible': {
            color: theme.palette.text.linkActive,
            textDecorationColor: 'inherit',
            outline: `${theme.palette.action.focus} auto 2px`,
          },

          '&.disabled, &.disabled:hover, &.disabled:active, &.disabled:focus-visible': {
            color: theme.palette.text.linkDisabled,
            textDecorationColor: 'inherit',
            cursor: 'not-allowed',
          },
        },
      },
    },
  },
});
